import { isEmpty } from './generalUtils'
import { isDeclinedRoute, isNotScheduledType } from './routeUtils'

const hasCalculatedArrayTime = data => {
  return !isEmpty(data) && data.some(item => item.arrivalTime !== null)
}

const hasDirectionRoute = data => {
  return !isEmpty(data) && !isEmpty(data.returnedRoute)
}

const resetCalculatedTimes = data => {
  return data.map(item => {
    item.arrivalTime = null
    return item
  })
}

const hasCustomStartStop = data => {
  return data.length > 0 && data[0].propertyId === null
}

const hasCustomEndStop = data => {
  return data.length > 1 && data[data.length - 1].propertyId === null
}

const homeStopsArray = data => {
  return data.filter(item => item.propertyId !== null)
}

const hasMoreThanOneStop = route => {
  return (
    !isEmpty(route) &&
    !isEmpty(route.calculatedArray) &&
    route.calculatedArray.length > 1
  )
}

const hasHomeStops = data => {
  return !isEmpty(data) && data.some(item => item.propertyId !== null)
}

const isCustomStopCalculated = data => {
  return !isEmpty(data) && data.latitude !== null
}

const isCustomStartExist = (stop, data) => {
  return isCustomStopCalculated(stop) && !hasCustomStartStop(data)
}

const isCustomEndExist = (stop, data) => {
  return isCustomStopCalculated(stop) && !hasCustomEndStop(data)
}

const routeDirectionCalculateCheck = routeData => {
  if (isDeclinedRoute(routeData) || isNotScheduledType(routeData)) {
    return isEmpty(routeData.fullCalculatedArray)
  }
  if (isEmpty(routeData.calculatedArray)) return true
  if (
    !isEmpty(routeData.calculatedArray) &&
    routeData.calculatedArray.length > 1 &&
    isEmpty(routeData.returnedRoute)
  ) { return true }
  return false
}

export {
  hasCalculatedArrayTime,
  hasDirectionRoute,
  resetCalculatedTimes,
  hasCustomStartStop,
  hasCustomEndStop,
  hasHomeStops,
  homeStopsArray,
  hasMoreThanOneStop,
  isCustomStopCalculated,
  isCustomStartExist,
  isCustomEndExist,
  routeDirectionCalculateCheck
}
